var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"center-align"},[_vm._v("Echo API page")]),_c('apiTest'),_c('div',{staticClass:"divider"}),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }